import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import { SimpleLayout } from '../../_metronic/layout/SimpleLayout';
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { MenuTestPage } from '../pages/MenuTestPage'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import DebitosTable from '../modules/debitos/components/DebitosTable';
import Dashboard from '../modules/global/Dashboard';

const ModulosPage = lazy(() => import('../modules/global/modulosPage'));


const PrivateRoutes = () => {
    const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
    const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
    const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
    const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
    const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
    const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
    const Home = lazy(() => import('../modules/home/Home'))
    const Cursos = lazy(() => import('../modules/cursos/Cursos'))
    const Tratamentos = lazy(() => import('../modules/tratamentos/Tratamentos'))
    const Associados = lazy(() => import('../modules/associados/Associados'))
    const Debitos = lazy(() => import('../modules/debitos/Debitos'))
    const Processos = lazy(() => import('../modules/processos/Processos'))
    const Audiencias = lazy(() => import('../modules/audiencias/Audiencias'))
    const Prazos = lazy(() => import('../modules/prazos/Prazos'))
    const Precatorios = lazy(() => import('../modules/precatorios/Precatorios'))
    const Calculos = lazy(() => import('../modules/calculos/Calculos'))
    const Publicacoes = lazy(() => import('../modules/publicacoes/Publicacoes'))
    const IniciaisPendentes = lazy(() => import('../modules/iniciais-pendentes/IniciaisPendentes'))
    const RelatoriosGerenciais = lazy(() => import('../modules/relatorios-gerenciais/RelatoriosGerenciais'))
    const NotFound = lazy(() => import('../modules/errors/NotFound'))

    return (
        <Routes>
            <Route element={<SimpleLayout />}>
                <Route path="modulos" element={<ModulosPage />} />
            </Route>
            <Route element={<MasterLayout />}>
                {/* Redirect to Dashboard after success login/registartion */}
                <Route path='auth/*' element={<Navigate to='/modulos' />} />
                {/* Pages */}
                <Route path='dashboard' element={<Dashboard />} />
                <Route path='builder' element={<BuilderPageWrapper />} />
                <Route path='menu-test' element={<MenuTestPage />} />
                {/* Lazy Modules */}
                <Route path='home'
                    element={
                        <SuspensedView>
                            <Home />
                        </SuspensedView>
                    }
                />
                <Route
                    path='/cursos/*'
                    element={
                        <SuspensedView>
                            <Cursos />
                        </SuspensedView>
                    }
                />
                <Route
                    path='/tratamentos/*'
                    element={
                        <SuspensedView>
                            <Tratamentos />
                        </SuspensedView>
                    }
                />
                <Route
                    path='/associados/*'
                    element={
                        <SuspensedView>
                            <Associados />
                        </SuspensedView>
                    }
                />
                <Route
                    path='/debitos/*'
                    element={
                        <SuspensedView>
                            <Debitos />
                        </SuspensedView>
                    }
                />
                <Route
                    path='/processos/*'
                    element={
                        <SuspensedView>
                            <Processos />
                        </SuspensedView>
                    }
                />
                <Route
                    path='/audiencias/*'
                    element={
                        <SuspensedView>
                            <Audiencias />
                        </SuspensedView>
                    }
                />
                <Route
                    path='/prazos/*'
                    element={
                        <SuspensedView>
                            <Prazos />
                        </SuspensedView>
                    }
                />
                <Route
                    path='/precatorios/*'
                    element={
                        <SuspensedView>
                            <Precatorios />
                        </SuspensedView>
                    }
                />
                <Route
                    path='/calculos/*'
                    element={
                        <SuspensedView>
                            <Calculos />
                        </SuspensedView>
                    }
                />
                <Route
                    path='/publicacoes/*'
                    element={
                        <SuspensedView>
                            <Publicacoes />
                        </SuspensedView>
                    }
                />
                <Route
                    path='/iniciais-pendentes/*'
                    element={
                        <SuspensedView>
                            <IniciaisPendentes />
                        </SuspensedView>
                    }
                />
                <Route
                    path='/relatorios-gerenciais/*'
                    element={
                        <SuspensedView>
                            <RelatoriosGerenciais />
                        </SuspensedView>
                    }
                />
                <Route
                    path='/error/404'
                    element={
                        <SuspensedView>
                            <NotFound />
                        </SuspensedView>
                    }
                />
                <Route
                    path='/profile/*'
                    element={
                        <SuspensedView>
                            <ProfilePage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='crafted/pages/profile/*'
                    element={
                        <SuspensedView>
                            <ProfilePage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='crafted/pages/wizards/*'
                    element={
                        <SuspensedView>
                            <WizardsPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='crafted/widgets/*'
                    element={
                        <SuspensedView>
                            <WidgetsPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='crafted/account/*'
                    element={
                        <SuspensedView>
                            <AccountPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='apps/chat/*'
                    element={
                        <SuspensedView>
                            <ChatPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='apps/user-management/*'
                    element={
                        <SuspensedView>
                            <UsersPage />
                        </SuspensedView>
                    }
                />
                {/* Page Not Found */}
                <Route
                    path='*'
                    element={
                        <SuspensedView>
                            <NotFound />
                        </SuspensedView>
                    }
                />
            </Route>
        </Routes>
    )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
    const baseColor = getCSSVariableValue('--bs-primary')
    TopBarProgress.config({
        barColors: {
            '0': baseColor,
        },
        barThickness: 1,
        shadowBlur: 5,
    })
    return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
